import { ScheduleOfActivities, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { scheduleOfActivitiesClient } from './ScheduleOfActivitiesClient';

const factory = createStudyEntityHookFactory<ScheduleOfActivities>(StudyEntityType.ScheduleOfActivities);

export const useScheduleOfActivities = factory.list(scheduleOfActivitiesClient.list);
export const useScheduleOfActivitiesState = factory.getState();
